import { Button } from "@/components/ui/button";
import { ArrowLeft, Target } from "lucide-react";
import { useLocation } from "wouter";
import { useAuth } from "@/hooks/useAuth";
import { useGoBack } from "@/hooks/useGoBack";
import { LevelEvolutionChart } from "@/components/LevelEvolutionChart";
import type { PlayerProfile } from "@shared/schema";

export function LevelEvolutionPage() {
  const [, setLocation] = useLocation();
  const goBack = useGoBack("/");
  const { user } = useAuth();
  const playerProfile = user?.profile as PlayerProfile | null;

  return (
    <div className="min-h-screen bg-background">
      <header 
        className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b"
        style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
      >
        <div className="container max-w-lg mx-auto px-4 py-3 flex items-center gap-3">
          <Button 
            variant="ghost" 
            size="icon"
            onClick={goBack}
            data-testid="button-back-level-detail"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-lg font-semibold flex items-center gap-2">
            <Target className="h-5 w-5 text-primary" />
            Evolución de Tu Nivel
          </h1>
        </div>
      </header>

      <main className="container max-w-lg mx-auto px-4 py-4 safe-area-bottom">
        <LevelEvolutionChart
          currentLevel={playerProfile?.skillLevel ?? 0}
          onInfoClick={() => setLocation("/como-funciona")}
          isFullscreen={true}
        />
      </main>
    </div>
  );
}

export default LevelEvolutionPage;
